import { Avatar, Box, Stack, Typography } from "@mui/material";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useSelector } from "react-redux";
import BookedAppointmentDialog from "../../app/clients/calendar/BookedAppointmentDialog";
import { appFonts } from "../../assets";
import appcolors from "../../constants/Colors";
import {
  fetchEventsDetailsById,
  updateAppointmentTime,
} from "../../services/appointments";
import { fetchAllTeamMembers } from "../../services/Team";
import Loader from "../Loader";
import ClientMenu from "../MenuDropDown/ClientMenu";
import SnackbarAlert from "../SnackBar";
import CustomEvent from "./CustomEvent";

const localizer = momentLocalizer(moment);
const DragAndDropCalendar = withDragAndDrop(Calendar);

const ResourceCalendar = ({
  openBlockTimeRef,
  allEvents,
  handleFetchEvents,
  setAllEvents,
}) => {
  const openDialog = useRef(null);
  const { user } = useSelector((state) => state.user);
  const openBookingDialogRef = useRef(null);
  const [allTeamMembers, setAllTeamMembers] = useState([]);
  const [appointmentDetails, setAppointmentDetails] = useState(null);
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  useEffect(() => {
    handleFetchAllTeamMembers();
  }, [selectedBranch]);

  const handleFetchAllTeamMembers = async () => {
    if (selectedBranch)
      try {
        setIsLoading(true);
        const responce = await fetchAllTeamMembers(selectedBranch[0]);
        setIsLoading(false);
        if (responce.status == 200 || responce.status == 201) {
          let data = responce?.data?.data;
          let temmpArrrr = [];

          data.map((item) => {
            let payload = {
              title: item?.firstname + " " + item?.lastname,
              icon: item?.image,
              id: item?._id,
            };
            temmpArrrr.push(payload);
          });

          setAllTeamMembers(temmpArrrr);
        } else {
          handleSnackbarVal(true, "error", responce?.data?.message);
        }
      } catch (error) {
        setIsLoading(false);
        console.log("🚀 ~ handleFetchAllBranches ~ error:", error);
        handleSnackbarVal(true, "error", error?.data?.message);
      }
  };

  const handleSelectSlot = ({ start, end, resourceId }) => {
    console.log(start, end, "asdasjdasjkdasjdsjadasjkjkdjk");
    // openDialog.current.isVisible({ data: { start, end, resourceId } });
  };

  const handleSelectEvent = async (event) => {
    if (event.status === "Blocked") {
      openBlockTimeRef.current.isVisible({ type: "edit" });
    } else {
      try {
        setIsLoading(true);
        const responce = await fetchEventsDetailsById(event?.appointmentId);
        console.log(responce, "responceresponceresponceresponce");

        setIsLoading(false);
        if (responce.status == 200 || responce.status == 201) {
          let data = responce?.data;
          console.log(data, "datadatadatadata");
          setAppointmentDetails(data);
          openBookingDialogRef.current.isVisible({
            ...data,
            event,
          });
        } else {
          handleSnackbarVal(true, "error", responce?.data?.message);
        }
      } catch (error) {
        setIsLoading(false);
        console.log("🚀 ~ handleFetchAllBranches ~ error:", error);
        handleSnackbarVal(true, "error", error?.data?.message);
      }
    }
  };

  const moveEvent = async ({ event, start, end, resourceId }) => {
    try {
      if (event.start !== start || event.end !== end) {
        const startDate = new Date(start);
        const endDate = new Date(end);
        const isoStartDate = startDate.toISOString();
        const isoEndDate = endDate.toISOString();

        const nextEvents = allEvents.map((existingEvent) => {
          return existingEvent.id === event.id
            ? { ...existingEvent, start, end, resourceId }
            : existingEvent;
        });
        setAllEvents(nextEvents);

        const params = {
          newTeamMemberID: resourceId,
          newStartTime: isoStartDate,
          newEndTime: isoEndDate,
          appointmentID: event.appointmentId,
          serviceID: event.serviceID,
        };
        setIsLoading(true);
        const response = await updateAppointmentTime(params);
        setIsLoading(false);

        if (response.status == 200 || response.status == 201) {
          handleSnackbarVal(true, "success", response?.data?.message);
          handleFetchEvents();
        } else {
          handleSnackbarVal(true, "error", response?.data?.message);
          handleFetchEvents();
        }
      } else {
        console.log("Drag-and-drop ignored (hover or no change detected).");
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error, "errorerror123");
      handleSnackbarVal(true, "error", error?.data?.message);
    }
  };

  const resourceHeader = ({ label }) => {
    const resource = allTeamMembers.find((res) => res.title === label);
    return (
      <Stack m={2} justifyContent={"center"} alignItems={"center"}>
        <Box borderRadius={"100%"} border={`2px solid ${appcolors.primary}`}>
          <Avatar
            src={resource?.icon || resource?.title.charAt(1)}
            alt={resource?.title}
            sx={{
              height: 60,
              width: 60,
              border: `2px solid ${appcolors.white}`,
            }}
          />
        </Box>
        <span
          style={{
            fontFamily: appFonts.Poppins,
            fontSize: "0.75rem",
            fontWeight: 500,
          }}
        >
          {resource?.title}
        </span>
      </Stack>
    );
  };

  const eventStyleGetter = (event) => {
    console.log(event, "Sdasdsadsad");
    let style = {
      borderRadius: "5px",
      color: "#000",
      display: "block",
      border: "2px solid #fdb6b6",
    };

    if (event.status == "Completed") {
      style.backgroundColor = "#D3FFE2";
      style.border = "2px solid #9ef9bd";
    } else if (event.status === "Accepted") {
      style.backgroundColor = "#E6F6FD";
      style.border = "2px solid #b3e2f7";
    } else {
      style.backgroundColor = "#FDEEE6";
      style.border = "2px solid #ffc4dcc4";
    }

    console.log(style, "libeede");

    return {
      className: "custom-event",
      style: style,
      title: "",
    };
  };

  const formats = {
    timeGutterFormat: (date, culture, localizer) =>
      localizer.format(date, "h:mm a", culture).replace(" ", "\n"),
    dayHeaderFormat: (date, culture, localizer) =>
      localizer.format(date, "dddd, MMMM DD, YYYY", culture),
  };

  const customToolbar = (prop) => {
    console.log(prop, "sdasjdasjdjdasj");
    console.log();
    return (
      <Stack
        p={2}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Box visibility={"hidden"}></Box>
        <Typography>{prop.label}</Typography>
        <ClientMenu />
      </Stack>
    );
  };

  // const CustomToolbar = () => {
  //   return <div />;
  // };

  return (
    <div>
      <DragAndDropCalendar
        localizer={localizer}
        events={allEvents}
        startAccessor="start"
        endAccessor="end"
        resources={allTeamMembers}
        resourceIdAccessor="id"
        resourceTitleAccessor="title"
        selectable
        onSelectSlot={handleSelectSlot}
        onSelectEvent={handleSelectEvent}
        onEventDrop={moveEvent}
        resizable
        onEventResize={moveEvent}
        defaultView="day"
        toolbar={true}
        views={["day", "week"]}
        formats={formats}
        tooltipAccessor={() => null}
        step={15}
        timeslots={2}
        components={{
          resourceHeader,
          event: CustomEvent,
          // toolbar: CustomToolbar,
        }}
        eventPropGetter={eventStyleGetter}
        style={{ height: "100vh" }}
      />

      {/* <MenuDialog ref={openDialog} openBlockTimeRef={openBlockTimeRef} /> */}

      <BookedAppointmentDialog
        ref={openBookingDialogRef}
        handleFetchEvents={handleFetchEvents}
      />
      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />
      <Loader isLoading={isLoading} />
    </div>
  );
};

export default ResourceCalendar;
